export default "__VITE_ASSET__DO1FD_Jt__"